import React, {Component} from 'react';
import {Link} from 'react-router'
import {Button} from 'elemental';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../../../actions/users';
import DataTable from '../../../components/data-table/data-table';

class UsersContainer extends Component {

    componentWillMount() {
        this.props.actions.loadUsers();
    }

    render() {
        const {items, total, page} = this.props.users;

        var config = {
            cols: [
                {
                    value: 'email',
                    header: 'Email'
                }, {
                    value: (item) => {
                        return `${item.first_name} ${item.last_name}`
                    },
                    header: 'First name, Last Name'
                }, {
                    value: (item) => {
                        return <Link to={`/admin/users/${item.id}`}>Edit</Link>
                    },
                    header: 'Actions'
                }
            ]
        };
        return (
            <div>
                <h3>Users</h3>
                <Link to="/admin/users/new">
                    <Button>New User</Button>
                </Link>
                <div className="panel">
                    <div className="panel-body">

                        <DataTable config={config} items={items} page={page} total={total}></DataTable>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(function(state) {
    return {users: state.admin.users.result};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions
        }, dispatch)
    };
})(UsersContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/users/users-container.js